import FieldRadioGroup, {
  ReplaceField,
} from "@features/builder/BulkNodesEditDialog/FieldsRadioGroup"
import { useGraph } from "@features/builder/graph/graphAtoms"
import { FindReplace } from "@mui/icons-material"
import { Button, Collapse, FormControlLabel, Grid, Switch, TextField, Tooltip } from "@mui/material"
import { useRef, useState } from "react"

type BulkReplaceSectionProps = {
  onReplace: (searchValue: string, replaceValue: string, field: ReplaceField) => void
}

const BulkReplaceSection = (props: BulkReplaceSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [selectedField, setSelectedField] = useState<ReplaceField>("label")

  const { isLocked } = useGraph()

  const searchInputRef = useRef<HTMLInputElement>(null)
  const replaceInputRef = useRef<HTMLInputElement>(null)

  const handleReplace = () => {
    const searchValue = searchInputRef.current?.value || ""
    const replaceValue = replaceInputRef.current?.value || ""
    props.onReplace(searchValue, replaceValue, selectedField)
  }

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <Tooltip
          title="Use it if you want to replace the same text part in multiple nodes"
          placement="top"
        >
          <FormControlLabel
            control={
              <Switch
                checked={isExpanded}
                onChange={(event) => setIsExpanded(event.target.checked)}
              />
            }
            label="Bulk replace"
          />
        </Tooltip>
      </Grid>

      <Grid item>
        <Collapse in={isExpanded}>
          <fieldset style={{ color: "rgba(0, 0, 0, 0.6)", borderColor: "rgba(0, 0, 0, 0.6)" }}>
            <legend>Replace text in multiple nodes within selected field</legend>
            <Grid container direction="column" spacing={1}>
              <Grid container item spacing={1}>
                <Grid item xs={6}>
                  <TextField
                    size="small"
                    fullWidth
                    label="Text to replace"
                    placeholder="Enter text to replace"
                    inputRef={searchInputRef}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    size="small"
                    fullWidth
                    label="Replace with"
                    placeholder="Enter replacement text"
                    inputRef={replaceInputRef}
                  />
                </Grid>
              </Grid>

              <Grid item>
                <FieldRadioGroup selectedField={selectedField} onChange={setSelectedField} />
              </Grid>

              <Grid item>
                <Button
                  fullWidth
                  startIcon={<FindReplace />}
                  variant="contained"
                  onClick={handleReplace}
                  disabled={isLocked}
                >
                  Replace
                </Button>
              </Grid>
            </Grid>
          </fieldset>
        </Collapse>
      </Grid>
    </Grid>
  )
}

export default BulkReplaceSection
